import { render, staticRenderFns } from "./HDTopFiveBuildingsForMonthToDate.vue?vue&type=template&id=4551e9b8&"
import script from "./HDTopFiveBuildingsForMonthToDate.vue?vue&type=script&lang=ts&"
export * from "./HDTopFiveBuildingsForMonthToDate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports